import {
    Box,
    Container,
    Grid,
    List,
    ListItem,
    ListItemText,
    Paper,
    Typography,
} from "@mui/material";
import { useState } from "react";
import VideoPopoverTrigger from "../VideoPopoverTrigger";

const MotivatorOverview = ({ motivators, title, secondaryTitle, backgroundColor }: {
    motivators: Array<{
        motivator: string,
        overview: string,
        index: number
    }>
    title: string,
    secondaryTitle: string,
    backgroundColor: string
}) => {
    const [motivatorIndex, setMotivatorIndex] = useState(motivators[0].index);
    const { motivator, overview } =
        motivators[motivatorIndex - motivators[0].index];
    return (
        <Box
            sx={{
                backgroundColor,
                padding: (theme) => theme.spacing(5, 0),
                minHeight: "70vh",
            }}
        >
            <Container>
                <header style={{ textAlign: "right" }}>
                    <Typography
                        sx={{ textAlign: "left" }}
                        variant="h3"
                        color="textSecondary"
                    >
                        {title}
                    </Typography>
                    <Typography sx={{ textAlign: "left" }} variant="h6">
                        {secondaryTitle}
                    </Typography>
                    <VideoPopoverTrigger src="/report/video/Your-Motivators.mp4" />
                </header>
                <Paper
                    sx={{
                        padding: (theme) => theme.spacing(2, 2),
                    }}
                    elevation={4}
                >
                    <Grid container justifyContent="center">
                        <Grid
                            container
                            item
                            alignItems="center"
                            justifyContent="center"
                            sm={3}
                            xs={12}
                        >
                            <List dense>
                                {motivators.map((m, i: number) => (
                                    <ListItem
                                        key={"listItem" + i}
                                        button
                                        onClick={() => setMotivatorIndex(m.index)}
                                    >
                                        <ListItemText
                                            sx={{
                                                color: (theme) =>
                                                    m.index === motivatorIndex
                                                        ? theme.palette.secondary.main
                                                        : "black",
                                            }}
                                        >
                                            {`#${m.index + 1} ${m.motivator}`}
                                        </ListItemText>
                                    </ListItem>
                                ))}
                            </List>
                        </Grid>
                        <Grid item sm={9} xs={12}>
                            <Typography
                                variant="h3"
                                color="primary"
                                sx={{
                                    padding: (theme) => theme.spacing(4, 0),
                                }}
                            >
                                {motivator}
                            </Typography>
                            <Typography variant="body1">{overview}</Typography>
                        </Grid>
                    </Grid>
                </Paper>
            </Container>
        </Box>
    );
};

export default MotivatorOverview;
